import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IEmpactProductResponse } from '../../models/empact-product-details.interface';
import { OfflineShopService } from '../offline-shop.service';

@Injectable()
export class ProductsResolver implements Resolve<any> {
    constructor(
        private productsSvc: OfflineShopService,
    ) { }

     resolve(route: ActivatedRouteSnapshot): Observable<IEmpactProductResponse> {
        const { id } = route.params;
        return this.productsSvc.getProductById(id);
    }
}
